module.exports = __webpack_public_path__ + "img/3768D4_0_0.fde1232.svg";